import { useNavigate } from "react-router-dom";
import { splashlogo } from "../constants/imports";
import Spinner from 'react-bootstrap/Spinner';


export default function (){

var navigate=useNavigate()

setTimeout(()=>{


  navigate('/w')
},3000)

    return(<><div className="main-cont  bg-customBlue flex justify-center items-center flex-col">
      <img   width='60%' src={splashlogo} />
        <Spinner animation="border" variant="light" />
         </div></>
  )}